import { Copy } from 'lucide-react';
import { useToast } from '@/hooks/use-toast';

interface ClickablePromptProps {
  text: string;
  className?: string;
  tab?: 'video' | 'image' | 'music' | 'speech';
}

export function ClickablePrompt({ text, className = '', tab }: ClickablePromptProps) {
  const { toast } = useToast();

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    
    // Copy to clipboard
    navigator.clipboard.writeText(text).catch(() => {});

    // Dispatch event to populate prompt field
    window.dispatchEvent(new CustomEvent('use-prompt', { 
      detail: { prompt: text, tab } 
    }));

    toast({
      title: 'Prompt copied!',
      description: 'Click generate to create with this prompt.',
    });
  };

  return (
    <p
      onClick={handleClick}
      className={`cursor-pointer hover:text-primary transition-colors group relative ${className}`}
      title="Click to use this prompt"
    >
      {text}
      <Copy className="h-3 w-3 absolute top-0 right-0 opacity-0 group-hover:opacity-50 transition-opacity" />
    </p>
  );
}